/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ExportTransferAllocateDto } from '../models/PagedResultDto_ExportTransferAllocateDto';
import type { PagedResultDto_GetTransferAllocateDto } from '../models/PagedResultDto_GetTransferAllocateDto';
import type { PagedResultDto_TransferAgentApiLogDto } from '../models/PagedResultDto_TransferAgentApiLogDto';
import type { PagedResultDto_TransferAllocateDetailDto } from '../models/PagedResultDto_TransferAllocateDetailDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto';
import type { Wealthlane_AwardService_Dtos_Release_StatusDto } from '../models/Wealthlane_AwardService_Dtos_Release_StatusDto';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_CreateDWACRequestDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_CreateDWACRequestDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_CreateUpdateTransferAllocateDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_CreateUpdateTransferAllocateDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_ExportPendingTransferAllocatedRequestDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_ExportPendingTransferAllocatedRequestDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_ImportTransferAllocateDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_ImportTransferAllocateDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransactionDetailOutputDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransactionDetailOutputDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDetailForTaBrokerDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDetailForTaBrokerDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateIdsDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateIdsDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateItemDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateItemDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateResponseDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateResponseDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateSummaryDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateSummaryDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAllocateService {

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param name 
     * @param containerStatusIds 
     * @returns PagedResultDto_GetTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateList(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
name?: string,
containerStatusIds?: Array<number>,
): CancelablePromise<PagedResultDto_GetTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-list',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'Name': name,
                'ContainerStatusIds': containerStatusIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param name 
     * @param containerStatusIds 
     * @returns PagedResultDto_GetTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateListForDrs(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
name?: string,
containerStatusIds?: Array<number>,
): CancelablePromise<PagedResultDto_GetTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-list-for-drs',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'Name': name,
                'ContainerStatusIds': containerStatusIds,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateName 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateCheckDuplicateTransferAllocateName(
transferAllocateName?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/check-duplicate-transfer-allocate-name',
            query: {
                'transferAllocateName': transferAllocateName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @param name 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocateTransferAllocateName(
transferAllocateId: string,
name?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-name/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            query: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param grantId 
     * @param awardTypeId 
     * @param fromDate 
     * @param toDate 
     * @param settlementTypeIds 
     * @param recordTypeId 
     * @param transactionIds 
     * @param isForDrs2StreetName 
     * @returns PagedResultDto_TransferAllocateDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateForAllocateRequests(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
grantId?: string,
awardTypeId?: string,
fromDate?: string,
toDate?: string,
settlementTypeIds?: Array<string>,
recordTypeId?: string,
transactionIds?: Array<string>,
isForDrs2StreetName?: boolean,
): CancelablePromise<PagedResultDto_TransferAllocateDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/for-allocate-requests',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
                'RecordTypeId': recordTypeId,
                'TransactionIds': transactionIds,
                'IsForDrs2StreetName': isForDrs2StreetName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param grantId 
     * @param awardTypeId 
     * @param fromDate 
     * @param toDate 
     * @param settlementTypeIds 
     * @param recordTypeId 
     * @param transactionIds 
     * @param isForDrs2StreetName 
     * @returns PagedResultDto_TransferAllocateDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateForDrsAllocateRequests(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
grantId?: string,
awardTypeId?: string,
fromDate?: string,
toDate?: string,
settlementTypeIds?: Array<string>,
recordTypeId?: string,
transactionIds?: Array<string>,
isForDrs2StreetName?: boolean,
): CancelablePromise<PagedResultDto_TransferAllocateDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/for-drs-allocate-requests',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
                'RecordTypeId': recordTypeId,
                'TransactionIds': transactionIds,
                'IsForDrs2StreetName': isForDrs2StreetName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateTransfer(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_CreateUpdateTransferAllocateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateTransferForDrs(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_CreateUpdateTransferAllocateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/transfer-for-drs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @param searchKeyWord 
     * @param grantId 
     * @param awardTypeId 
     * @param fromDate 
     * @param toDate 
     * @param settlementTypeIds 
     * @param recordTypeId 
     * @param transactionIds 
     * @param isForDrs2StreetName 
     * @returns PagedResultDto_TransferAllocateDetailDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateAllocatedList(
id: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
searchKeyWord?: string,
grantId?: string,
awardTypeId?: string,
fromDate?: string,
toDate?: string,
settlementTypeIds?: Array<string>,
recordTypeId?: string,
transactionIds?: Array<string>,
isForDrs2StreetName?: boolean,
): CancelablePromise<PagedResultDto_TransferAllocateDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/{id}/allocated-list',
            path: {
                'id': id,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
                'SearchKeyWord': searchKeyWord,
                'GrantId': grantId,
                'AwardTypeId': awardTypeId,
                'FromDate': fromDate,
                'ToDate': toDate,
                'SettlementTypeIds': settlementTypeIds,
                'RecordTypeId': recordTypeId,
                'TransactionIds': transactionIds,
                'IsForDrs2StreetName': isForDrs2StreetName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppTransferAllocateTransfer(
transferAllocateId: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/transfer-allocate/transfer/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocateTransfer(
transferAllocateId: string,
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_CreateUpdateTransferAllocateDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate/transfer/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppTransferAllocateTransferAllocateItem(
requestBody?: Array<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateIdsDto>,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-item',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateItemId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateItemDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateItemDetail(
transferAllocateItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-item-detail/{transferAllocateItemId}',
            path: {
                'transferAllocateItemId': transferAllocateItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateItemId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransactionDetailOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransactionDetailByTransferAllocateItemId(
transferAllocateItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransactionDetailOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transaction-detail-by-transfer-allocate-item-id/{transferAllocateItemId}',
            path: {
                'transferAllocateItemId': transferAllocateItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateItemId 
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTaxDetailsByTransferAllocateItemId(
transferAllocateItemId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/tax-details-by-transfer-allocate-item-id/{transferAllocateItemId}',
            path: {
                'transferAllocateItemId': transferAllocateItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateTransferAllocate(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_CreateDWACRequestDto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateById(
transferAllocateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-by-id/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Release_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Release_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Release_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateItemStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Release_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/item-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_Release_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateContainerStatuses(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Release_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/container-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_TransferAgentApiLogDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAgentApiLogs(
transferAllocateId?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_TransferAgentApiLogDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-agent-api-logs',
            query: {
                'TransferAllocateId': transferAllocateId,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTaTransferAllocateProperties(
transferAllocateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TaTransferAllocatePropertiesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/ta-transfer-allocate-properties/{TransferAllocateId}',
            path: {
                'TransferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateSummaryByTransferAllocateId(
transferAllocateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-summary-by-transfer-allocate-id/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateExportPendingTransferAllocatedShares(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_ExportPendingTransferAllocatedRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/export-pending-transfer-allocated-shares',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns string OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateExportPendingDrsRegistrationShares(
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_ExportPendingTransferAllocatedRequestDto,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/export-pending-drs-registration-shares',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferStatusIds 
     * @param containerStatusIds 
     * @param createdDate 
     * @param companyIds 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ExportTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocatePendingTransferAllocatesShare(
transferStatusIds?: Array<number>,
containerStatusIds?: Array<number>,
createdDate?: string,
companyIds?: Array<string>,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ExportTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share',
            query: {
                'TransferStatusIds': transferStatusIds,
                'ContainerStatusIds': containerStatusIds,
                'CreatedDate': createdDate,
                'CompanyIds': companyIds,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocatePendingTransferAllocatesShare(
requestBody?: Array<Wealthlane_AwardService_Dtos_TransferAllocate_ImportTransferAllocateDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferStatusIds 
     * @param containerStatusIds 
     * @param createdDate 
     * @param companyIds 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ExportTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocatePendingTransferAllocatesShareForDrs(
transferStatusIds?: Array<number>,
containerStatusIds?: Array<number>,
createdDate?: string,
companyIds?: Array<string>,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ExportTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-for-drs',
            query: {
                'TransferStatusIds': transferStatusIds,
                'ContainerStatusIds': containerStatusIds,
                'CreatedDate': createdDate,
                'CompanyIds': companyIds,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocatePendingTransferAllocatesShareForDrs(
requestBody?: Array<Wealthlane_AwardService_Dtos_TransferAllocate_ImportTransferAllocateDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-for-drs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocatePendingTransferAllocatesShareDetail(
transferId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-detail/{transferId}',
            path: {
                'transferId': transferId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocatePendingTransferAllocatesShareDetailForDrs(
transferId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_ExportTransferAllocateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-detail-for-drs/{transferId}',
            path: {
                'transferId': transferId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateBackgroundImportTransferAllocates(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/background-import-transfer-allocates',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateBackgroundImportTransferAllocatesForDrs(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate/background-import-transfer-allocates-for-drs',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param forDrs 
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static putApiAwardApiAppTransferAllocatePendingTransferAllocatesShareCore(
forDrs?: boolean,
requestBody?: Array<Wealthlane_AwardService_Dtos_TransferAllocate_ImportTransferAllocateDto>,
): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-core',
            query: {
                'forDrs': forDrs,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferStatusIds 
     * @param containerStatusIds 
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateDashboard(
transferStatusIds?: Array<number>,
containerStatusIds?: Array<number>,
companyId?: Array<string>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-dashboard',
            query: {
                'TransferStatusIds': transferStatusIds,
                'ContainerStatusIds': containerStatusIds,
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferStatusIds 
     * @param containerStatusIds 
     * @param companyId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAllocateDashboardForDrs(
transferStatusIds?: Array<number>,
containerStatusIds?: Array<number>,
companyId?: Array<string>,
): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDashboardDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-allocate-dashboard-for-drs',
            query: {
                'TransferStatusIds': transferStatusIds,
                'ContainerStatusIds': containerStatusIds,
                'CompanyId': companyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDetailForTaBrokerDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppTransferAllocateTransferAndAllocateStatistics(
transferAllocateId: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_TransferAllocateDetailForTaBrokerDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/transfer-allocate/transfer-and-allocate-statistics/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
